import logo from '../logo.png';

const facebook = `${process.env.PUBLIC_URL}/img/facebook.png`;
const twitter = `${process.env.PUBLIC_URL}/img/twitter.png`;
const instagram = `${process.env.PUBLIC_URL}/img/instagram.png`;
const linkedin = `${process.env.PUBLIC_URL}/img/linkedin.svg`;

const Footer = () => {
  return (
    <footer>
          <h3 className="text-xl text-center">
            WhistleBlower for a <span className="text-primary">green</span>{" "}
            world
          </h3>

          <div className="flex flex-wrap p-10 gap-2 justify-between max-w-[800px]">
            <div className="flex-wrap">
              <a href="#" className="flex justify-center mb-2">
                <img src={logo} className="w-24" alt="logo" />
              </a>
              <div className="inline-flex gap-2">
                <a href="https://www.facebook.com/" target="_blank">
                  <img src={facebook} className="h-5" alt="facebook" />
                </a>
                <a href="https://x.com/" target="_blank">
                  <img src={twitter} className="h-5" alt="twitter" />
                </a>
                <a href="https://instagram.com/" target="_blank">
                  <img src={instagram} className="h-5" alt="instagram" />
                </a>
                <a href="https://www.linkedin.com/" target="_blank">
                  <img src={linkedin} className="h-5" alt="linkedin" />
                </a>
              </div>
            </div>

            <div className="text-sm">
              <h4 className="text-md pb-2">IMPORTANT LINKS</h4>
              <p>Terms of Use</p>
              <p>Privacy Policy</p>
              <p>State Information</p>
              <p>Past variable rates</p>
            </div>

            <div className="text-sm">
              <h4 className="text-md pb-2">COMPANY INFOMRATIONS</h4>
              <p>About Us</p>
              <p>Questions</p>
              <p>Information</p>
            </div>

            <div className="text-sm">
              <h4 className="text-md pb-2">CUSTOMER SERVICE</h4>
              <p>Partnership</p>
              <p>Contact Us</p>
            </div>
          </div>

          <p className="text-end text-sm pr-2">
            © Copyright {new Date().getFullYear()}. All right reserved.
            WhistleBlower
          </p>
        </footer>
  );
}

export default Footer;